import type { FC } from 'react';
import React from 'react';

import { stackingOrder } from './config';
import { StackingContext } from './stacking-context';
import type { IProps } from './models';

/**
 * Компонент управляет stacking order других компонентов через [React.Context](https://reactjs.org/docs/context.html).
 */
export const Stack: FC<IProps> = ({
    children,
    /**
     * Значение z-index по-умолчанию.
     * Если StackingContext.Consumer передал большее значение, то будет использоваться оно.
     */
    value = stackingOrder.DEFAULT,
}) => (
    <StackingContext.Consumer>
        {previousValue => {
            const currentValue = Math.max(value, previousValue);
            const nextValue = currentValue + 1;

            return (
                <StackingContext.Provider value={nextValue}>
                    {children(currentValue)}
                </StackingContext.Provider>
            );
        }}
    </StackingContext.Consumer>
);
